import { MenuOption } from "src/app/types";
import {
  AppUI,
  AsThreshold,
  PrecaptureChecks,
  PreCaptureStatus,
  Template,
  VideoSelfiePhase2Layout,
} from "@identy/identy-face";
import { LocalizationItem } from "../../../modules/models/types";
import { environment } from "src/environments/environment";

const VIDEO_SELFIE_OPTIONS: MenuOption[] = environment.faceOnly ? [] : [
  {
    label: "Video Selfie Options",
    type: "group",
    options: [
      {
        label: "Enable Video Recording",
        field: "vs_enable_video_recording",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Enable Video Challenge",
        field: "vs_enable_video_challenge",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Challenge Text",
        field: "vs_challenge_text",
        type: "text",
        defaultValue: "Please look at the camera and smile!",
      },
      {
        label: "Phase 2 Layout",
        field: "vs_phase2_layout",
        type: "single-radio",
        values: Object.keys(VideoSelfiePhase2Layout || {}).filter((k) =>
          isNaN(Number(k)),
        ),
        defaultValue: "BOTTOM",
      },
    ],
  },
];

export const CONTEXT_MENU_CONFIG: MenuOption[] = [
  {
    label: "Face Options",
    type: "group",
    options: [
      {
        label: "Enable AS",
        field: "enable_as",
        type: "boolean",
        defaultValue: true,
      },
      {
        label: "Enable ICAO Checks",
        field: "enable_icao_checks",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Enable Retake Dialog",
        field: "enable_retake",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Skip Device Check",
        field: "skip_device_check",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Allow Camera Select",
        field: "allow_camera_select",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Enable Eye Status",
        field: "enable_eye_status",
        type: "boolean",
        defaultValue: true,
      },
      {
        label: "Rear Camera",
        field: "assisted",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Download Templates",
        field: "download",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Show Training",
        field: "capture_training",
        type: "boolean",
        defaultValue: true,
      },
      {
        label: "Background Removal",
        field: "enableBackgroundRemoval",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "Background Color",
        field: "backgroundColor",
        type: "text",
        defaultValue: "#ffffff",
      },
      {
        label: "Enable DF",
        field: "enable_df",
        type: "boolean",
        defaultValue: false,
      }
    ],
  },
  ...VIDEO_SELFIE_OPTIONS,
  {
    label: "AS Threshold",
    type: "group",
    options: [
      {
        label: "",
        field: "as_threshold",
        type: "single-radio",
        values: Object.keys(AsThreshold),
        defaultValue: AsThreshold.BALANCED_VERY_HIGH,
      },
    ],
  },
  {
    label: "DF Threshold",
    type: "group",
    options: [
      {
        label: "",
        field: "df_threshold",
        type: "single-radio",
        values: Object.keys(AsThreshold),
        defaultValue: AsThreshold.BALANCED_VERY_HIGH,
      },
    ],
  },
  {
    label: "Templates",
    type: "group",
    options: [
      {
        label: "",
        field: "templates",
        type: "multi-checkbox",
        values: Object.keys(Template),
        defaultValue: [Template.PNG, Template.JPEG],
      },
    ],
  },
  {
    label: "App UI",
    type: "group",
    options: [
      {
        label: "",
        field: "app_ui",
        type: "single-radio",
        values: Object.keys(AppUI),
        defaultValue: AppUI.STANDARD,
      },
    ],
  },
  {
    label: "Localization",
    type: "group",
    options: [
      {
        label: "",
        field: "localization",
        type: "single-radio",
        values: [],
        defaultValue: "English",
      },
    ],
  },
  {
    label: "Timeout",
    type: "group",
    options: [
      {
        label: "",
        field: "timeout",
        type: "single-radio",
        values: ["10", "20", "30", "40", "50"],
        defaultValue: "30",
      },
    ],
  },
  {
    label: "ICAO PreChecks",
    type: "group-mode-checkbox",
    options: [
      {
        label: "Enable ICAO Strict",
        field: "icao_strict",
        type: "boolean",
        defaultValue: false,
      },
      {
        label: "",
        field: "icao_threshold_ui",
        type: "multi-checkbox",
        values: Object.keys(PrecaptureChecks),
        defaultValue: [],
      },
    ],
  },
];
